export enum HistoryPushCause {
  REDIRECT = 'REDIRECT',
  UNAUTHORIZED = 'UNAUTHORIZED',
}
